export default "__VITE_ASSET__a8a4e1bb__"